import React from "react";
import {AVATAR_SIZE, CaveatAvatar} from './CaveatAvatars';

const containerStyle = {
  width: (AVATAR_SIZE + 2) * 6 + 26,
  minWidth: (AVATAR_SIZE + 2) * 6 + 26,
  paddingRight: 20,
  paddingLeft: 20,
  overflow: "hidden",
  whiteSpace: "nowrap",
  flex: 1,
  maxWidth: (AVATAR_SIZE + 2) * 6 + 26
};

//export to allow access from reports (will keep it consistent if algorithm changes again)
export const getCaveatScores = (caveats) => {
  var scores = caveats
  .filter(c => c.score <= 0 && !c.static)
  .sort((a, b) => a.score - b.score)
  .reduce((scores, caveat) => {
    if (!scores[caveat.score]) {
      scores[caveat.score] = 1;
    } else {
      scores[caveat.score]++;
    }
    return scores;
  }, {});
  return scores;
}

export const posAttributes = (caveats) => caveats.filter(caveat => caveat.score > 0 && !caveat.static);
export const staticCaveats = (caveats) => caveats.filter(caveat => caveat.static);

const CondensedCaveatAvatars = ({ onClick, caveats, style }) => {
  var scores = getCaveatScores(caveats);
  var posAttCount = posAttributes(caveats).length;
  var staticCavCount = staticCaveats(caveats).length;

  return (
    <div
      style={{
        ...containerStyle,
        cursor: "pointer",
        textAlign: "right",
        position: "relative",
        ...(style || {})
      }}
      onClick={onClick}
    >
      {
        Object.keys(scores).map((score) => <CaveatAvatar score={score} count={scores[score]} key={"score-"+score} />)
      }
      { posAttCount > 0 && <CaveatAvatar score={2} count={posAttCount} key={"score-"+2} />}
      { staticCavCount > 0 && <CaveatAvatar score={0} count={staticCavCount} key={"score-"+0} />}
    </div>
  );
};

CondensedCaveatAvatars.style = containerStyle;

export default CondensedCaveatAvatars;
